import { render } from "./BoolRenderer_round.vue?vue&type=template&id=70075c39"
import script from "./BoolRenderer_round.vue?vue&type=script&lang=js"
export * from "./BoolRenderer_round.vue?vue&type=script&lang=js"

import "./BoolRenderer_round.vue?vue&type=style&index=0&id=70075c39&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__